module.exports = __webpack_public_path__ + "static/media/NF.167da269.png";